import Link, { LinkProps } from '@mui/material/Link';
import React from 'react';

export type LinkButtonProps = Pick<
	LinkProps,
	'children' | 'underline' | 'variant' | 'color' | 'style' | 'sx' | 'onClick' | 'href' | 'target' | 'onMouseDown' | 'textAlign'
> & {
	component?: React.ElementType;
	/** HTML button type — use "button" to prevent form submission */
	type?: 'button' | 'submit' | 'reset';
};

/** A button that looks like a link */
export function LinkButton({ component, variant, type, ...otherProps }: LinkButtonProps) {
	const resolvedComponent = component ?? 'button';
	const resolvedType = type ?? (resolvedComponent === 'button' ? 'button' : undefined);
	return <Link component={resolvedComponent} variant={variant ?? 'body2'} type={resolvedType} {...otherProps} />;
}
